import { Routes, Route } from "react-router-dom";

import Login from "../pages/auth/Login";
import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";

import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "../pages/dashboard/Dashboard";
import Trips from "../pages/trips/Trips";
import TripDetails from "../pages/trips/TripDetails";
import TripForm from "../pages/trips/TripForm";
import TripVideos from "../pages/trip-videos/TripVideos";
import TripVideoDetails from "../pages/trip-videos/TripVideoDetails";
import TripVideoForm from "../pages/trip-videos/tripVideoForm";
import Providers from "../pages/providers/Providers";
import UnavailableBookingDay from "../pages/trips/UnavailableBookingDay";
import ProviderDetails from "../pages/providers/ProviderDetails";
import ProviderForm from "../pages/providers/ProviderForm";
import ConnectedUsers from "../pages/connected-users/ConnectedUsers";
import UsersActivity from "../pages/users-activity/UsersActivity";
import Customers from "../pages/customers/Customers";
import CustomerDetails from "../pages/customers/CustomerDetails";
import CustomerForm from "../pages/customers/CustomerForm";
import BlockUsers from "../pages/block-users/BlockUsers";
import Bookings from "../pages/bookings/Bookings";
import BookingDetails from "../pages/bookings/BookingDetails";
import BookingForm from "../pages/bookings/BookingForm";
import Chats from "../pages/chats/Chats";
import Categories from "../pages/categories/Categories";
import CategoryDetails from "../pages/categories/CategoryDetails";
import CategoryForm from "../pages/categories/CategoryForm";
import Cities from "../pages/cities/Cities";
import CityForm from "../pages/cities/CityForm";
import Banners from "../pages/banners/Banners";
import BannerForm from "../pages/banners/BannerForm";
import BannerDetails from "../pages/banners/BannerDetails";
import Transactions from "../pages/transactions/Transactions";
import Notifications from "../pages/notifications/Notifications";
import NotificationForm from "../pages/notifications/NotificationForm";
import NotificationDetails from "../pages/notifications/NotificationDetails";

const AppRoutes = () => {
  return (
    <Routes>
      {/* AUTH ROUTES */}

      <Route element={<AuthLayout />}>
        <Route path="/" element={<Login />} />
      </Route>

      {/* PROTECTED ROUTES */}

      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trip-details/:id" element={<TripDetails />} />
        <Route path="/trip-form/:id?" element={<TripForm />} />
        <Route
          path="/trip/unavailable-booking-day/:tripId"
          element={<UnavailableBookingDay />}
        />
        <Route path="/trip-videos" element={<TripVideos />} />
        <Route path="/trip-video-details/:id" element={<TripVideoDetails />} />
        <Route path="/trip-video-form/:tripId" element={<TripVideoForm />} />
        {/* <Route path="/providers" element={<Providers />} />
        <Route path="/provider-details/:id" element={<ProviderDetails />} />
        <Route path="/provider-form/:id?" element={<ProviderForm />} />
        <Route path="/connected-users" element={<ConnectedUsers />} />
        <Route path="/users-activity" element={<UsersActivity />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customer-details/:id" element={<CustomerDetails />} />
        <Route path="/customer-form/:id?" element={<CustomerForm />} />
        <Route path="/block-users" element={<BlockUsers />} /> */}
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/booking-details/:id" element={<BookingDetails />} />
        {/* <Route path="/booking-form/:id?" element={<BookingForm />} /> */}
        {/* <Route path="/chats" element={<Chats />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/category-details/:id" element={<CategoryDetails />} />
        <Route path="/category-form/:id?" element={<CategoryForm />} />
        <Route path="/cities" element={<Cities />} />
        <Route path="/city-form/:id?" element={<CityForm />} />
        <Route path="/banners" element={<Banners />} />
        <Route path="/banner-form/:id?" element={<BannerForm />} />
        <Route path="/banner-details/:id" element={<BannerDetails />} /> */}
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/notification-form/:id?" element={<NotificationForm />} />
        <Route path="/notification-details/:id" element={<NotificationDetails />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
